import React, { useEffect, useState, createRef } from "react";
import { Bar } from "react-chartjs-2";
import { scaleLinear } from "d3-scale";
import {
  ComposableMap,
  Geographies,
  Geography,
  Sphere,
  Graticule,
} from "react-simple-maps";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { useScreenshot } from "use-react-screenshot";
import Layout from "../../../components/Layout";
import { request } from "../../../config/API";
import { Col, Row, DatePicker, Space, List, Button } from "antd";
import Countup from "react-countup";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
import dateWithSuffix from "../../../helpers/dateWithSuffix";
import greetUser from "../../../helpers/greetUser";
import { useSelector } from "react-redux";
import styles from "./Dashboard.module.css";
import { FiUser, FiUsers } from "react-icons/fi";
import { AiOutlineQrcode } from "react-icons/ai";
import { COLORS } from "../../../config/theme";
import moment from "moment";
// import { utils, writeFile } from "xlsx";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title
);
const Dashboard = () => {
  const { RangePicker } = DatePicker;
  const { user } = useSelector((state) => state.auth);

  const [stats, setStats] = useState({});
  const [cardsWiseRank, setCardsWiseRank] = useState([]);
  const [leadsWiseRank, setleadsWiseRank] = useState([]);
  const [hourWiseAnalysis, setHourWiseAnalysis] = useState([]);
  const [dayWiseAnalysis, setDayWiseAnalysis] = useState([]);
  const [geoAnalysis, setGeoAnalysis] = useState([]);
  const [topContries, setTopContries] = useState([]);
  const [topCities, setTopCities] = useState([]);
  const [topActivePortals, setTopActivePortals] = useState([]);
  const [planAnalysis, setPlanAnalysis] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const { primaryDark } = COLORS;
  ///////////////////////////////////////////////////////////////////
  const hourAnalysisOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        // display: true,
        text: "Hour-Wise Analysis",
      },
    },
  };
  const dailyAnalysisOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        // display: true,
        text: "Day-Wise Analysis",
      },
    },
  };
  const hourAnalysis = {
    labels: hourWiseAnalysis.map((item) =>
      moment(item?._id, "hh").format("LT")
    ),
    datasets: [
      {
        label: "Hour-Wise",
        data: hourWiseAnalysis.map((item) => item.count),
        backgroundColor: "rgba(75, 124, 249, 0.5)",
      },
    ],
  };

  const dayAnalysis = {
    labels: dayWiseAnalysis.map((item) =>
      moment(item?._id === 7 ? 0 : item?._id, "d").format("ddd")
    ),
    datasets: [
      {
        label: "Day-Wise",
        data: dayWiseAnalysis.map((item) => item.count),
        backgroundColor: "rgba(75, 124, 249, 0.5)",
      },
    ],
  };
  const optionsTopCountries = {
    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: true,
        text: "Top Countries",
      },
    },
  };
  const optionsTopCities = {
    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: true,
        text: "Top Cities",
      },
    },
  };
  const TopContry = {
    labels: topContries.map((item) => item.key),
    datasets: [
      {
        label: "Countries",
        data: topContries.map((item) => item.count),
        borderColor: "rgb(75, 124, 249)",
        backgroundColor: "rgba(75, 124, 249, 0.5)",
      },
    ],
  };
  const TopCities = {
    labels: topCities.map((item) => item.key),
    datasets: [
      {
        label: "Cities",
        data: topCities.map((item) => item.count),
        borderColor: "rgb(75, 124, 249)",
        backgroundColor: "rgba(75, 124, 249, 0.5)",
      },
    ],
  };
  const geoUrl = "/GeoFeatures.json";
  const colorScale = scaleLinear()
    .domain([0.29, 0.68])
    .range(["#4bb3f9", "#4b7cf9"]);

  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // const weekday = [
  //   "Monday",
  //   "Tuesday",
  //   "Wednesday",
  //   "Thursday",
  //   "Friday",
  //   "Saturday",
  //   "Sunday",
  // ];
  // function formatTime(hourString) {
  //   const hour = +hourString % 24;
  //   return (hour % 12 || 12) + ":" + "00" + (hour < 12 ? "AM" : "PM");
  // }
  const ref = createRef(null);
  const [image, takeScreenshot] = useScreenshot();

  useEffect(() => {
    if (image) {
      const linkSource = `${image}`;
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);

      downloadLink.href = linkSource;
      downloadLink.target = "_self";
      downloadLink.download = `${new Date()}.png`;
      downloadLink.click();
    }
  }, [image]);
  const handleExport = () => {
    takeScreenshot(ref.current);

    // return;
    // const general = [
    //   {
    //     Admin: stats.admin,
    //     "Sub Users": stats.subuser,
    //     "Wave Cards": `${stats.qr}`,
    //   },
    // ];
    // const hourWise = hourWiseAnalysis.map(({ _id, count }) => ({
    //   Hours: `${formatTime(_id)} - ${formatTime(_id + 1)}`,
    //   Count: count,
    // }));
    // const dayWise = dayWiseAnalysis.map(({ _id, count }) => ({
    //   Day: weekday[_id - 1],
    //   Count: count,
    // }));

    // const cardWiseRank = cardsWiseRank.map(({ fullName, count }) => ({
    //   "Admin Name": fullName,
    //   "Total Cards": count,
    // }));

    // const leadWiseRank = leadsWiseRank.map(({ fullName, count }) => ({
    //   "Admin Name": fullName,
    //   "Total Cards": count,
    // }));

    // const topActivePortal = topActivePortals.map(({ admin, count }) => ({
    //   "Admin Name": admin.fullName,
    //   "Admin Email": admin.email,
    // }));
    // const topCitiesRanks = topCities.map(({ key, count }) => ({
    //   Cities: key,
    //   Percentage: `${count}`,
    // }));
    // const topContriesRank = topContries.map(({ key, count }) => ({
    //   Countries: key,
    //   Percentage: `${count}`,
    // }));
    // const geo = geoAnalysis.map(({ ISO3, count }) => ({
    //   IOS: ISO3,
    //   Percentage: `${count}%`,
    // }));

    // let worksheet = utils.json_to_sheet(general);
    // let worksheet1 = utils.json_to_sheet(hourWise);
    // let worksheet2 = utils.json_to_sheet(dayWise);
    // let worksheet3 = utils.json_to_sheet(cardWiseRank);
    // let worksheet4 = utils.json_to_sheet(leadWiseRank);
    // let worksheet5 = utils.json_to_sheet(topActivePortal);
    // let worksheet6 = utils.json_to_sheet(topCitiesRanks);
    // let worksheet7 = utils.json_to_sheet(topContriesRank);
    // let worksheet8 = utils.json_to_sheet(geo);

    // let workbook = utils.book_new();
    // utils.book_append_sheet(workbook, worksheet, "General");
    // utils.book_append_sheet(workbook, worksheet1, "Hour-Wise");
    // utils.book_append_sheet(workbook, worksheet2, "Day-Wise");
    // utils.book_append_sheet(workbook, worksheet3, "Cards Wise Rank");
    // utils.book_append_sheet(workbook, worksheet4, "Lead Wise Rank");
    // utils.book_append_sheet(workbook, worksheet5, "Top Active Portal");
    // utils.book_append_sheet(workbook, worksheet6, "Top Cities");
    // utils.book_append_sheet(workbook, worksheet7, "Top Contries");
    // utils.book_append_sheet(workbook, worksheet8, "Geo");

    // writeFile(workbook, "Data.xlsx");
  };
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const getStats = () => {
    // setStats({});
    setIsLoading(true);
    request
      .get("dashboard/superadmin", {
        // params: { scan: scanParam, queryDateRange: dateRange },
        params: { queryDateRange: dateRange },
      })
      .then(({ data: { data } }) => {
        setCardsWiseRank(data.cardsWiseRank);
        setleadsWiseRank(data.leadsWiseRank);
        setPlanAnalysis(data.planAnalysis);
        setHourWiseAnalysis(data.hourWiseAnalysis);
        setDayWiseAnalysis(data.dayWiseAnalysis);
        setGeoAnalysis(data.finalGeoAnalysis);
        setTopContries(data.finalCountries);
        setTopCities(data.finalCities);
        setTopActivePortals(data.topActivePortal);
        setStats(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err?.response);
        const error = err?.response?.data?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getStats();

    //eslint-disable-next-line
  }, [dateRange]);
  // useEffect(() => {
  //   dispatch(getSubscribedPlan());
  // }, []);

  const date = new Date();
  const userName = user?.fullName.split(" ");
  const flex = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
    borderRadius: 13,
    padding: "25px 50px",
    gap: 15,
  };
  return (
    <Layout heading="Dashboard">
      <Space size={24} style={{ marginBottom: "1rem" }}>
        <RangePicker
          disabledDate={(d) => !d || d.isAfter(new Date())}
          onChange={(date) => {
            if (date && date[0]?._d) {
              const newRange = { startDate: date[0]?._d, endDate: date[1]?._d };
              setDateRange(newRange);
            } else {
              setDateRange({ startDate: null, endDate: null });
            }
          }}
        />
        <Button
          shape="round"
          type="primary"
          style={{
            background: isLoading ? "#edededed" : primaryDark,
            borderColor: isLoading ? "#edededed" : primaryDark,
            color: isLoading ? "gray" : "white",
          }}
          onClick={handleExport}
          disabled={isLoading === true}
        >
          Export
        </Button>
      </Space>
      <div ref={ref}>
        <Row className={styles.box} xs={6} md={10}>
          <Col xs={24} md={20}>
            <div className={styles.greet}>
              <h2>{greetUser()},</h2>
              <h2>
                {userName[0]} {!userName[1] ? "" : userName[1][0] + "."}
              </h2>
            </div>
          </Col>

          <Col
            xs={24}
            md={4}
            className={styles.dateContainer}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div className={styles.date}>
              <h2 style={{ margin: 0 }}>
                {date.toLocaleDateString("en-US", { weekday: "long" })},{" "}
                {date.toLocaleDateString("en-US", { month: "long" })}{" "}
                {dateWithSuffix()}
              </h2>
            </div>
          </Col>
        </Row>

        <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
          <Space
            direction="horizontal"
            style={{
              marginBottom: "1rem",
              justifyContent: "center",
              width: "100%",
            }}
            wrap={true}
          >
            <Col>
              <div style={{ ...flex, margin: "0 1rem" }}>
                <FiUser
                  style={{
                    color: "white",
                    background: primaryDark,
                  }}
                  className={styles.counterIcons}
                />
                <h2 className={styles.counterText}>
                  Admin{stats?.admin > 1 && "s"}
                </h2>
                <Countup
                  end={stats?.admin}
                  start={0}
                  duration={1}
                  className={styles.counter}
                />
              </div>
            </Col>
            <Col>
              <div style={{ ...flex, margin: "0 1rem" }}>
                <FiUsers
                  style={{
                    color: "white",
                    background: primaryDark,
                  }}
                  className={styles.counterIcons}
                />
                <h2 className={styles.counterText}>
                  Sub User{stats?.subuser > 1 && "s"}
                </h2>
                <Countup
                  end={stats?.subuser}
                  start={0}
                  duration={1}
                  className={styles.counter}
                />
              </div>
            </Col>
            <Col>
              <div style={{ ...flex, margin: "0 1rem" }}>
                <AiOutlineQrcode
                  style={{
                    color: "white",
                    background: primaryDark,
                  }}
                  className={styles.counterIcons}
                />
                <h2 className={styles.counterText}>Wave Cards</h2>
                <Countup
                  end={stats?.qr}
                  start={0}
                  duration={1}
                  className={styles.counter}
                />
              </div>
            </Col>
          </Space>
        </Row>

        <Row
          xs={24}
          md={24}
          style={{ marginTop: "1rem" }}
          justify="space-evenly"
        >
          <Col
            xs={24}
            md={5}
            style={{
              padding: "1rem",
              boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
              borderRadius: "13px",
            }}
          >
            <Row justify="center">
              <p style={{ fontWeight: "700", marginBottom: "1rem" }}>
                Top performing Clients (Card-Wise)
              </p>
            </Row>
            <Row justify="space-between">
              <p style={{ fontWeight: "600" }}>Names</p>
              <p style={{ fontWeight: "600" }}>Quantity</p>
            </Row>
            <List
              itemLayout="horizontal"
              loading={isLoading}
              dataSource={cardsWiseRank}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <p style={{ fontWeight: "400" }}>{item?.fullName}</p>
                    }
                  />
                  <div>{item?.count}</div>
                </List.Item>
              )}
            />
          </Col>
          <Col
            xs={24}
            md={5}
            style={{
              padding: "1rem",
              boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
              borderRadius: "13px",
            }}
          >
            <Row justify="center">
              <p style={{ fontWeight: "700", marginBottom: "1rem" }}>
                Top performing Clients Card (Lead-Wise)
              </p>
            </Row>
            <Row justify="space-between">
              <p style={{ fontWeight: "600" }}>Names</p>
              <p style={{ fontWeight: "600" }}>Quantity</p>
            </Row>

            <List
              itemLayout="horizontal"
              dataSource={leadsWiseRank}
              loading={isLoading}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <p style={{ fontWeight: "400" }}>{item?.fullName}</p>
                    }
                  />
                  <div>{item?.count}</div>
                </List.Item>
              )}
            />
          </Col>
          <Col
            xs={24}
            md={5}
            style={{
              padding: "1rem",
              boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
              borderRadius: "13px",
            }}
          >
            <Row justify="center">
              <p style={{ fontWeight: "700", marginBottom: "1rem" }}>
                Top Active Portal
              </p>
            </Row>
            <Row justify="space-between">
              <p style={{ fontWeight: "600" }}>Admin Names</p>
              {/* <p>Quantity</p> */}
            </Row>
            <List
              itemLayout="horizontal"
              dataSource={topActivePortals}
              loading={isLoading}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <p style={{ fontWeight: "400" }}>
                        {item?.admin?.fullName}
                      </p>
                    }
                  />
                </List.Item>
              )}
            />
          </Col>
          <Col
            xs={24}
            md={5}
            style={{
              padding: "1rem",
              boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
              borderRadius: "13px",
            }}
          >
            <Row justify="center">
              <p style={{ fontWeight: "700", marginBottom: "1rem" }}>
                Plan Analysis
              </p>
            </Row>
            <Row justify="space-between">
              <p style={{ fontWeight: "600" }}>Plans</p>
              <p style={{ fontWeight: "600" }}>Count</p>
            </Row>
            <List
              itemLayout="horizontal"
              dataSource={planAnalysis}
              loading={isLoading}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={<p style={{ fontWeight: "400" }}>{item?._id}</p>}
                  />
                  <div>{item?.count}</div>
                </List.Item>
              )}
            />
          </Col>
        </Row>
        <Row
          xs={24}
          md={24}
          justify="space-around"
          style={{
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Col
            md={24}
            lg={10}
            style={{
              padding: "1rem",
              boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
              borderRadius: "13px",
            }}
          >
            <Row justify="center">
              <p style={{ fontWeight: "700", marginBottom: "1rem" }}>
                Hour-Wise Analysis
              </p>
            </Row>
            <Bar
              loading={isLoading}
              options={hourAnalysisOptions}
              data={hourAnalysis}
            />
          </Col>
          <Col
            md={24}
            lg={10}
            style={{
              padding: "1rem",
              boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
              borderRadius: "13px",
            }}
          >
            <Row justify="center">
              <p style={{ fontWeight: "700", marginBottom: "1rem" }}>
                Day-Wise Analysis
              </p>
            </Row>
            <Bar
              loading={isLoading}
              options={dailyAnalysisOptions}
              data={dayAnalysis}
            />
          </Col>
        </Row>
        <Row
          xs={24}
          md={24}
          justify="space-around"
          style={{ marginTop: "1rem", marginBottom: "1rem" }}
        >
          <Col
            md={24}
            lg={10}
            style={{
              padding: "1rem",
              boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
              borderRadius: "13px",
            }}
          >
            <Row justify="center">
              <p style={{ fontWeight: "700", marginBottom: "1rem" }}>
                Top Country
              </p>
            </Row>
            <Bar options={optionsTopCountries} data={TopContry} />
          </Col>
          <Col
            md={24}
            lg={10}
            style={{
              padding: "1rem",
              boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
              borderRadius: "13px",
            }}
          >
            <Row justify="center">
              <p style={{ fontWeight: "700", marginBottom: "1rem" }}>
                Top City
              </p>
            </Row>
            <Bar options={optionsTopCities} data={TopCities} />
          </Col>
        </Row>
        <Row xs={24} md={24} justify="center">
          <Col
            xs={24}
            md={12}
            style={{
              boxShadow: "2px 1px 15px -3px rgba(0, 0, 0, 0.1)",
              borderRadius: "13px",
            }}
          >
            <p
              style={{
                fontWeight: "700",
                marginTop: "1rem",
                marginBottom: "1rem",
                textAlign: "center",
              }}
            >
              Geo Analysis
            </p>
            <ComposableMap
              projection="geoMercator"
              projectionConfig={{
                center: [0, 30],
                scale: 110,
              }}
            >
              <Sphere stroke="#E4E5E6" strokeWidth={0} />
              <Graticule stroke="#E4E5E6" strokeWidth={0} />
              {geoAnalysis.length > 0 && (
                <Geographies geography={geoUrl}>
                  {({ geographies }) =>
                    geographies.map((geo) => {
                      const d = geoAnalysis.find((s) => s.ISO3 === geo.id);
                      return (
                        <Geography
                          key={geo.rsmKey}
                          geography={geo}
                          fill={d ? colorScale(d.count) : "#ebebeb"}
                        />
                      );
                    })
                  }
                </Geographies>
              )}
            </ComposableMap>
          </Col>
        </Row>
        {/* <Row className={styles.box} gutter={[10, 10]} style={{ marginTop: 24 }}>
        <Col span={24}>
          <ScanChart
            setScanParam={setScanParam}
            isLoading={isLoading}
            data={stats}
          />
        </Col>
      </Row> */}
      </div>
    </Layout>
  );
};

export default Dashboard;
